import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../../services/api.service';

export default function useGetClient() {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Récupère la fiche complète d'un client (configuration, usines, templates,
   * administrateurs).
   * @param {number} clientId - L'identifiant du client
   * @returns {Promise<object|null>} Le client, ou null en cas d'erreur
   */
  const fetchClient = async (clientId) => {
    try {
      setIsLoading(true);

      const response = await fleetApi.get(`/super-admin/clients/${clientId}`);

      if (response.status !== 200) {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }

      return response.data.client;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    fetchClient,
  };
}
